import { createFileRoute } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/hooks/useAuth";
import { PostFlightPage } from "@/features/post-flight/pages/PostFlightPage";
import {
  parsePostFlightSearch,
  searchForWindow,
} from "@/features/post-flight/lib/post-flight-list";
import { postFlightOpportunitiesQueryOptions } from "@/lib/queries";

export const Route = createFileRoute("/_authenticated/post-flight/")({
  validateSearch: parsePostFlightSearch,
  loader: ({ context }) => {
    const tenantId = useAuth.getState().activeTenantId;
    if (!tenantId) return;
    return context.queryClient
      .ensureQueryData(postFlightOpportunitiesQueryOptions(tenantId))
      .catch(() => undefined);
  },
  component: PostFlightIndexRoute,
});

function PostFlightIndexRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <PostFlightPage
      windowDays={search.window}
      adHash={search.ad}
      onWindowChange={(window) => {
        void navigate({ search: searchForWindow(window) });
      }}
      onAdSelect={(ad) => {
        void navigate({ search: { window: search.window, ad } });
      }}
      onAdClose={() => {
        void navigate({ search: { window: search.window } });
      }}
    />
  );
}
